import Swal from 'sweetalert2';

export async function handleStudioApiResponse<T>(
    promise: Promise<T>,
    onSuccess: (data: T) => void,
    onFinally?: () => void,
    t?: (key: string) => string,
    onCatch?: () => void
): Promise<void> {
    try {
        const res: any = await promise;

        if (res?.errors) {
            const errorMessages = Object.values(res.errors).flat().join('\n');
            Swal.fire(errorMessages, '', 'error');
        } else if (res?.error) {
            Swal.fire(res.error, '', 'error');
        } else {
            onSuccess(res);
        }
    } catch (error: any) {
        if (error?.data?.errors) {
            const errorMessages = Object.values(error.data.errors).flat().join('\n');
            Swal.fire(errorMessages, '', 'error');
        } else {
            Swal.fire(t?.('general.anErrorOccured') ?? 'Bir hata oluştu.', '', 'error');
        }

        onCatch?.();
    } finally {
        onFinally?.();
    }
}

export const playBeep = () => {
    const AudioContextClass = window.AudioContext || (window as any).webkitAudioContext;
    const ctx = new AudioContextClass();

    const oscillator = ctx.createOscillator();
    oscillator.type = 'sine';
    oscillator.frequency.setValueAtTime(540, ctx.currentTime); // A4 tone
    oscillator.connect(ctx.destination);
    oscillator.start();
    oscillator.stop(ctx.currentTime + 0.2); // 200ms beep
};

export const isValidBarcode = (barcode: string): boolean => {
    return /^\d{13}$/.test(barcode);
};

export const generateUUID = () =>
    '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) =>
        (Number(c) ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (Number(c) / 4)))).toString(16)
    );

export const generateCompressedPreview = (file: File): Promise<string> => {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const maxWidth = 150; // or any small width for preview
                const scale = maxWidth / img.width;

                canvas.width = maxWidth;
                canvas.height = img.height * scale;

                const ctx = canvas.getContext('2d');
                if (ctx) {
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                    const dataUrl = canvas.toDataURL('image/jpeg', 0.1); // 0.1 = 10% quality
                    resolve(dataUrl);
                } else {
                    resolve(URL.createObjectURL(file)); // fallback
                }
            };
            img.src = event.target?.result as string;
        };
        reader.readAsDataURL(file);
    });
};
